import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { caseActions } from "../../../../store/case";
import { caseQuickUpdate } from "../../../../lib/fetchApi";
import FalseInputNumber from "../../../common/FalseInputNumber";
import CustomSelect from "../../../common/interactive/CustomSelect";

export default function BillingOrder({itemData}) {
    const dispatch = useDispatch()

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector((state) => state.case.activeCase);
    
    const [data, setData] = useState(null);

    const updateHandler = async (data) => {
        
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }
        let disptachBody = {
            folder: 'major_meds',
            item: {
                itemId: itemData.id,
                field: data.identifier.field,
                value: data.data.value,
            }
        }

        let sameBilling = activeCase.major_meds.find(item => ((item.billing_order == data.data.value) && (item.id !== itemData.id)))
        
        if (sameBilling) {
            disptachBody.specificRelation = {
                specificItemId: sameBilling.id,
                field: 'billing_order',
                value: itemData.billing_order
            }
        }
        
        dispatch(caseActions.modifyActiveCase(disptachBody))

        await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (sameBilling) {
            await caseQuickUpdate(userToken, activeCase.case.id, {
                type: data.identifier.type,
                type_id: sameBilling.id,
                fields: {
                    billing_order: itemData.billing_order,
                }
            })
        }
      
        
    }

    useEffect(() => {
        if (activeCase) {
            let arr = activeCase.major_meds;           

            if (arr.length > 0) {
                let options = [];

                arr.forEach((element, index) => {
                    options.push({
                        label: index+1,
                        value: index+1,
                        isDisabled: index==0 ? true : false
                    });
                });
                setData(options);
            } else {
                setData(null);
            }
        }
    }, [activeCase]);

    return <div>{data && <>
        {(!itemData.is_primary_insurance || Number(itemData.is_primary_insurance) == 0) ? 
            <CustomSelect action={updateHandler} label={'Billing Order'} optionsData={data} preSelectedValue={itemData.billing_order}  identifier={{type: 'case_major_med', field: 'billing_order', type_id: itemData.id}}/> :
            <FalseInputNumber label={"Billing Order"} value={1} minWidth={158}/>
        }
    </>}</div>;
}
